export const PERMISSIONS = [
  { id: 0, label: 'Owner', type: 'Owner', permission: 2 },
  { id: 1, label: 'Viewer', type: 'Viewer', permission: 0 },
  { id: 2, label: 'Consumer', type: 'Consumer', permission: 1 },
]
